import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn } from '@angular/router';
import { DirtyFormService } from '@app/services/dirty-form.service';
import { ConfirmationService } from 'primeng/api';
import { Observable } from 'rxjs';

/**
 * Guard global para bloquear navegación cuando hay cambios sin guardar.
 * Se usa en canActivateChild del layout principal para cubrir todas las rutas hijas.
 */
const confirmLeave = (dirtySvc: DirtyFormService, confirm: ConfirmationService) => {
  if (!dirtySvc.isDirty()) return true;

  return new Observable<boolean>((observer) => {
    confirm.confirm({
      message: '¿Está seguro que quiere salir? Perderá los datos ingresados aquí.',
      header: 'Datos Sin Guardar',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Salir',
      rejectLabel: 'Cancelar',
      accept: () => {
        dirtySvc.reset();
        observer.next(true);
        observer.complete();
      },
      reject: () => {
        observer.next(false);
        observer.complete();
      }
    });
  });
};

export const unsavedChangesGuard: CanActivateChildFn = () => {
  const dirtySvc = inject(DirtyFormService);
  const confirm = inject(ConfirmationService);
  return confirmLeave(dirtySvc, confirm);
};

export const unsavedActivateGuard: CanActivateFn = () => {
  const dirtySvc = inject(DirtyFormService);
  const confirm = inject(ConfirmationService);
  return confirmLeave(dirtySvc, confirm);
};
